import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  type DialogSize,
} from "@capacit-com/lara-law-shared-ui";
import { Button } from "@capacit-com/lara-law-shared-ui";
import { X, Save } from "lucide-react";
import { PropsWithChildren } from "react";

type BulkDialogProps = {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  title: string;
  description: string;
  confirmText: string;
  confirmIcon?: "save" | "none";
  onConfirm: () => void;
  confirmDisabled?: boolean;
  confirmVariant?:
    "default" | "destructive" | "outline" | "secondary" | "ghost" | "link";
  isLoading?: boolean;
  size?: DialogSize;
  cancelText?: string;
};

export function BulkDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmText,
  confirmIcon = "save",
  onConfirm,
  confirmDisabled,
  confirmVariant = "default",
  isLoading,
  size,
  cancelText = "Annuller",
  children,
}: PropsWithChildren<BulkDialogProps>) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size={size}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        {children}

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
          >
            <X className="w-4 h-4 mr-1" />
            {cancelText}
          </Button>
          <Button
            onClick={onConfirm}
            disabled={!!confirmDisabled || isLoading}
            variant={confirmVariant}
          >
            {confirmIcon === "save" && <Save className="w-4 h-4 mr-1" />}
            {isLoading
              ? confirmVariant === "destructive"
                ? "Fjerner..."
                : "Gemmer..."
              : confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
